import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_20: FaireProductEntity = {
  token: "starter_collection_20",
  type: "product",
  name: "Slow Smoked Mackerel",
  brandName: "Fishwife",
  imageUrl: "",
  priceDollars: 11,
  msrpDollars: 22,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
